const QbCode = '11';
const SuperMemberCode = '12';
const JxCode = '1';
const YpCode = '2';
const MoreCode = '13';
const PlusCode = 'plus';

const CouponsTypeEnums = [
  {
    code: JxCode, // 精选专区
  },
  {
    code: YpCode, // 样品券专区
  },
  {
    code: '3', // 会员专区
  },
  {
    code: PlusCode, // plus专区
  },
  {
    code: '5', //MRO专区
  },
  {
    code: QbCode, // 券包专区
  },
  {
    code: SuperMemberCode, //超级会员日专区
  },
  {
    code: MoreCode, //更多优惠专区
  },
];

const SortListEnums = [
  {
    name: '综合',
    code: '',
  },
  {
    name: '金额',
    code: 'coupon_amount',
  },
  {
    name: '门槛',
    code: 'min_order_money',
  },
];

const StepEnums = {
  one: 1,
  second: 2,
  third: 3,
};

const CouponTypeEnums = {
  discount: 'discount', // 折扣券
  freight: 'freight', // 运费券
  mro_freight: 'mro_freight', // MRO运费券
};

export {
  CouponsTypeEnums,
  QbCode,
  SortListEnums,
  SuperMemberCode,
  JxCode,
  YpCode,
  CouponTypeEnums,
  StepEnums,
  PlusCode,
  MoreCode,
};
